import { forwardRef } from "react";
import PropTypes from "prop-types";
import styles from "./index.css";

const InformationIcon = forwardRef(({ ariaLabel, children, onClick }, ref) => (
  <button
    ref={ref}
    onClick={onClick}
    className={styles.button}
    aria-label={ariaLabel}
  >
    {children}
  </button>
));

InformationIcon.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onClick: PropTypes.func.isRequired
};

InformationIcon.displayName = "InformationIcon";

export default InformationIcon;
